<template>
<div>
  <div class="clickable" @click="active = !active">
    <span class="row space-between">
      <h2>{{courseModule.title}}</h2>
      <i class="material-icons" >
        {{ active ? "keyboard_arrow_down" : "keyboard_arrow_right" }}
      </i>
    </span>
    <span style="font-size: 12px">Module {{count}}</span>
  </div>
  <div v-if="active">
    <div 
      v-for="(lesson, i) in courseModule.lessons"
      :key="lesson.id"
      :class="{active: lesson === activeLesson}"
      class="lesson clickable"
      @click="$emit('lessonClicked', lesson)">
      <div class="row align-center">
        <h3>{{lesson.title}}</h3>
      </div>
        
      <div class="lesson--title row align-center">
        <i style="font-size: 14px; margin-right: 5px;" class="material-icons" v-if="lesson.completed">
          check_circle_outline
        </i>
        Lesson {{i + 1}}
      </div>
    </div>
  </div>
</div> 
</template>

<script>
export default {
  props: ["courseModule", "count", "activeLesson"],
  data() {
    return {
      active: false
    }
  },
};

</script>

<style lang="less" scoped>
.lesson {
  opacity: .6;
  border-left-style: solid;
  border-left-width: 3px;
  border-left-color: white;
  padding: 8px 12px;
  font-family: 'Quicksand', sans-serif;

  .number {
    font-size: 14px;
  }
  &--title {
    font-size: 12px;
  }
  & + .active {
    opacity: 1;
    color: white !important;
  }
}
</style>
